/**
 * Reverse geocoding (coordenadas → endereço) via proxy do bitbox-server (Google Geocoding API).
 */

import { getUser } from "../authentication";

function norm(s) {
  return (s || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
}

/**
 * @param {number} lat
 * @param {number} lon
 * @param {AbortSignal} [signal]
 * @returns {Promise<{
 *   logradouro: string,
 *   numero: string,
 *   bairroNome: string,
 *   cidade: string,
 *   estado: string,
 *   cep: string
 * }|null>}
 */
export async function reverseGeocode(lat, lon, signal) {
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;

  try {
    const user = await getUser();
    if (!user || !user.service || !user.sessao || !user.sessao.token) {
      return null;
    }

    const params = new URLSearchParams({
      lat: String(lat),
      lng: String(lon),
      token: user.sessao.token,
    });
    const url = `${user.service}/api/geocode/reverse?${params.toString()}`;

    const res = await fetch(url, {
      signal,
      headers: { Accept: "application/json" },
    });
    if (!res.ok) return null;

    const body = await res.json();
    if (!body || body.error !== 0 || !body.data) return null;

    const data = body.data;
    return {
      logradouro: data.logradouro || "",
      numero: data.numero || "",
      bairroNome: data.bairroNome || "",
      cidade: data.cidade || "",
      estado: data.estado || "",
      cep: data.cep || "",
    };
  } catch (e) {
    if (e && e.name === "AbortError") throw e;
    return null;
  }
}

export { norm };
